export default class Routes {
  static HOME = '/';
  static SKILLS = '/skills';
  static EXPERIENCE = '/experience';
  static EDUCATION = '/education';
}
